import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {ClanShortInfo, InvitationDto} from "@/store/clan/types";
import {ImageButton} from "@/scenes.ui/image-button";
import Container = Phaser.GameObjects.Container;
import {ClanBonusPanel} from "@/scenes.ui.clan/clan-bonus-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ClanStartPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, inv: InvitationDto, applyCallback: (clanId: number) => unknown,
                ratingCallback: () => unknown, createCallback: () => unknown) {
        super(scene, canvas, Tr('klan'));

        let shift = 0;
        if (inv.invitingClans && inv.invitingClans.length > 0) {

            this.initInvitingSubPanel(scene, inv.invitingClans, 0, applyCallback);
            shift = 30;

        } else {
            let hopeForInviteText = TextUtils.addTextByFamily(scene, Tr('ozhidayte.priglashenija.v.klan.'), 0, -135,
                '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);
            this.add(hopeForInviteText);
        }

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('takzhe.vi.mozhete.pereyti.k.reytingu.klanov'), 0, shift,
            '#a2ff82', 14, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        this.add([blockFirst]);

        this.addCustomButton(-100, 160,Tr('reyting'), Keys.UI_ART_BROWN_BUTTON, undefined, Keys.CLAN_RATING, () => {
            if (ratingCallback != null) {
                ratingCallback();
            }
        });

        this.addCustomButton(100, 160,Tr('sozdat.klan'), Keys.UI_ART_GREEN_BUTTON, undefined, Keys.IC_100_MITHRIL, createCallback);
        let buyPriceText = TextUtils.addText(scene, String(inv.clanCreationPrice), 100, 196, '#ffffff', 22, 'bold', 200);
        this.add(buyPriceText);
    }

    private initInvitingSubPanel(scene: Scene, clans: ClanShortInfo[], index: number, applyCallback: (clanId: number) => unknown): void {
        index = index % clans.length;
        if (index < 0) {
            index += clans.length;
        }
        let clan = clans[index];

        let container = new Container(scene);

        let light = SpriteUtils.addSprite(this.scene, 0, -170, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 2, 0.5);

        let invLabel = TextUtils.addTextByFamily(scene, Tr('vas.priglashajut.v.klan'), 0, -200,
            '#909090', 15, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

        let clanName = TextUtils.addTextByFamily(scene, clan.name, 0, light.y / CU.S,
            '#ffd465', 22, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        let clanBonusPanel = new ClanBonusPanel(scene, 0, clanName.y / CU.S + 30,
            clan.clanExpRatio, clan.clanDefenceChance, clan.raidDistance, clan.gears, false);

        let clanInfo = TextUtils.addTextByFamily(scene, Tr('ur.dot') + clan.level + ', ' + Tr('uchastnikov') + clan.membersCurr + '/' + clan.membersMax, 0, clanBonusPanel.y / CU.S + 30,
            '#767575', 14, 'normal', 400, Fonts.MYRIADPRO_REGULAR);

        let butt = SpriteUtils.addSprite(this.scene, 0, clanInfo.y / CU.S + 45, Keys.GREEN_HORIZONTAL_BUTTON);

        let separator = SpriteUtils.addSprite(this.scene, 0, butt.y / CU.S + 38, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.6);

        butt.setInteractive().on('pointerup', () => {
            applyCallback(clan.id);
        });

        let acceptText = TextUtils.addTextByFamily(scene, Tr('vstupit'), 0, butt.y / CU.S,
            '#ffffff', 18, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

        container.add([light, invLabel, butt, clanName, clanBonusPanel, clanInfo, acceptText, separator]);

        if (clans.length > 1) {
            const leftButton = new ImageButton(this.scene, clanName.x / CU.S - 185, clanName.y / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ARROW_LEFT);
            const rightButton = new ImageButton(this.scene, clanName.x / CU.S + 185, clanName.y / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ARROW_RIGHT);

            container.add(leftButton);
            container.add(rightButton);

            leftButton.setCallback(() => {
                container.setVisible(false);
                container.destroy();
                this.initInvitingSubPanel(scene, clans, index - 1, applyCallback);
            });

            rightButton.setCallback(() => {
                container.setVisible(false);
                container.destroy();
                this.initInvitingSubPanel(scene, clans, index + 1, applyCallback);
            });
        }

        this.add(container);
    }

    protected onClose(): void {

    }

}
